// react
import React, { useContext} from 'react';

// react component for creating dynamic tables
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/core | components 
import { makeStyles } from "@material-ui/core/styles";

// icons | @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import GestaoAnamneseForm from './GestaoAnamneseForm';
import GestaoAnamnesePrint from './GestaoAnamnesePrint';

// services
import { SessionContext } from "beaktShared/services/session";
import { formateDate } from "beaktShared/helpers/masks";
import { useGetApi, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

export default function GestaoAnamneseList({ clienteId, estabelecimentoId }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const endPoint = "FichaAnamnese/";

    const [loadingForm, setLoadingForm] = React.useState(false);
    const [showFormViewAnmnese, setshowFormViewAnmnese] = React.useState(false);
    const [itemPrint, setItemPrint] = React.useState({});
    const [showFormPrit, setshowFormPrit] = React.useState(false);

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);
    };
    
    // Endpoint para busca da lista
    const getEndPoint = () => {
        let endPointGet = ""; 
        endPointGet = endPoint + "byestabelecimento/" + estabelecimentoId + "/" + clienteId;
        return endPointGet;
    }
    
    // Carrega lista Anamnese
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());

    const handleView = (resetItem) => {
        if(resetItem) {
            sendScrollToTOP();
        }
        let show = showFormViewAnmnese === true ? false : true;
        setshowFormViewAnmnese(show);
    };

    const handleAdd = item => {
        var newitem = "";
        newitem = {...item};

        if (newitem !== null)
        {
            setLoadingForm(true);
            UsePostApi(endPoint, newitem).then(result=> {                
                setLoadingForm(false);

                if(result.status !== 201)
                {                                     
                    showNotification(result.message.message,'danger');
                    return false; 
                }
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList); 
                handleView(true);
                showNotification(t('information_message.registered_successfully'),'success');
                return true;                
            });
        }

        handleView(true);
    }

    const handleDetail = (value) => {
        setItemPrint(value);
        setshowFormPrit(value);        
    }

    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    }

    //colunas Table e Ações
    const columnsProp = [
        {
            Header: t('label.registered_in'),
            accessor: "dataCadastro",
            width: 150,
            Cell: (props) => {
                const custom_date = props.value == null ? "" : formateDate(props.value)
                return <span>{custom_date}</span>
            }
        },
        {
            Header: 'Paciente',
            accessor: "clienteNome",
        },
        {
            Header: 'Biomédico',
            accessor: "usuarioNome",
        },
    ];

    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                            <Button
                        justIcon
                        round
                        simple                            
                        color="info"
                        className="info"
                        onClick={() => handleDetail(row.original)}
                    >
                        <Search />
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false,
            width: 100,
        }
    ];

    const columns = [...columnsProp, ...columnsAcao];
    
    return (
        <>
            {showFormPrit && 
                <GestaoAnamnesePrint 
                    item={itemPrint} 
                    handleView={handleDetail}  />
            }

            {!showFormPrit &&
                <>
                    {showFormViewAnmnese &&
                        <GestaoAnamneseForm 
                            clienteId={clienteId} 
                            estabelecimentoId={estabelecimentoId}
                            handleView={handleView}
                            addItem={handleAdd}
                            loading={loadingForm} />
                    }

                    {!showFormViewAnmnese &&
                        <>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <Card>
                                        <CardHeader color="primary" icon>
                                            <CardIcon color="primary">
                                                <Assignment />
                                            </CardIcon>
                                            <h4 className={classes.cardIconTitle}>{t('information_message.anamnesis')}</h4>
                                        </CardHeader>
                                        <CardBody>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                                    <Button
                                                        color="primary" 
                                                        className={classes.newButton}
                                                        onClick={() => handleView(true)}>
                                                        {t('button.new')}
                                                    </Button>
                                                </GridItem>
                                            </GridContainer>

                                            {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                                            <ReactTable
                                                loading={isLoadingList}
                                                data={list}
                                                columns={columns}
                                                filterable={false}
                                                defaultFilterMethod={noCaseSensitive}
                                                defaultPageSize={10}
                                                minRows={5}
                                                showPaginationBottom={true}
                                                className="-striped -highlight"
                                                previousText={t('button.previous')}
                                                nextText={t('button.next')}
                                                loadingText={t('label.loading') + "..."}
                                                noDataText={t('information_message.no_records_found') + "!"}
                                                pageText={t('label.page')}
                                                ofText={t('label.of')}
                                                rowsText={t('label.rows')}
                                            />

                                        </CardBody>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </>
                    }
                </>
            }
        </>
    );
}